import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

import { invoiceDetailKey } from './use-invoice-detail';

import type { InvoiceRow } from '../types';

export interface CompletePlaceholderInput {
  invoice_type: 'Advance' | 'Provisional' | 'Final Settlement' | 'Adjustment';
  invoice_number: string;
  issue_date: string;
  original_due_date: string;
  company_name?: string;
  issuer_company_name?: string;
  remarks?: string;
  total_amount?: number;
  vat_amount?: number;
}

export interface CompletePlaceholderArgs {
  invoiceId: string;
  body: CompletePlaceholderInput;
}

export function useCompletePlaceholderMutation() {
  const queryClient = useQueryClient();
  return useMutation<InvoiceRow, Error, CompletePlaceholderArgs>({
    mutationFn: ({ invoiceId, body }) =>
      apiRequest<InvoiceRow>(`/invoices/${encodeURIComponent(invoiceId)}/complete-placeholder`, {
        method: 'POST',
        body,
      }),
    onSuccess: (_data, { invoiceId }) => {
      void queryClient.invalidateQueries({ queryKey: invoiceDetailKey(invoiceId) });
      void queryClient.invalidateQueries({ queryKey: ['bl-order-invoices'] });
      void queryClient.invalidateQueries({ queryKey: ['order-advance-invoices'] });
    },
  });
}
